<img *ngIf="!matCard && !isLoading" [src]="src" [style.width]="width + '%'" [style.height]="height" alt="Photo">
<img *ngIf="matCard && !isLoading" mat-card-image [src]="src" [style.width]="width + '%'" [style.height]="height"
  alt="Photo">

<mat-spinner *ngIf="isLoading" [diameter]="35"></mat-spinner>